<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <div class="header-row">
      <div>
        <h1>Gestão de produção de livros</h1>
        <div class="sub">Pedidos com NF-e e etiqueta dos Correios emitidas. Inicie a produção, baixe os arquivos e confirme o envio.</div>
      </div>
    </div>

    <!-- Indicadores -->
    <div class="kpis" *ngIf="indicators as ind">
      <button type="button" class="kpi stage-kpi" [class.on]="form.value.status === STATUS.aguardaProducao"
              [attr.title]="'Filtrar por ' + STATUS.aguardaProducao" (click)="toggleStatus(STATUS.aguardaProducao)">
        <span class="dot dot-chip-pend"></span>
        <div class="t">Aguardando produção</div>
        <div class="big">{{ ind.waitingProduction.orders }}<small>pedido{{ ind.waitingProduction.orders === 1 ? '' : 's' }}</small></div>
        <div class="side">{{ ind.waitingProduction.books }} livro{{ ind.waitingProduction.books === 1 ? '' : 's' }} · {{ ind.waitingProduction.pages }} págs</div>
        <div class="l" [class.is-late]="ind.waitingProduction.lateCount > 0">
          <ng-container *ngIf="ind.waitingProduction.lateCount > 0">{{ ind.waitingProduction.lateCount }} atrasado{{ ind.waitingProduction.lateCount === 1 ? '' : 's' }} (etiqueta há mais de 2 dias)</ng-container>
          <ng-container *ngIf="ind.waitingProduction.lateCount === 0 && ind.waitingProduction.orders > 0">mais antigo: {{ ind.waitingProduction.oldestDays }} d aguardando</ng-container>
          <ng-container *ngIf="ind.waitingProduction.orders === 0">nenhum pedido aguardando</ng-container>
        </div>
      </button>

      <button type="button" class="kpi stage-kpi" [class.on]="form.value.status === STATUS.emProducao"
              [attr.title]="'Filtrar por ' + STATUS.emProducao" (click)="toggleStatus(STATUS.emProducao)">
        <span class="dot dot-chip-info"></span>
        <div class="t">Em produção</div>
        <div class="big">{{ ind.inProduction.orders }}<small>pedido{{ ind.inProduction.orders === 1 ? '' : 's' }}</small></div>
        <div class="side">{{ ind.inProduction.books }} livro{{ ind.inProduction.books === 1 ? '' : 's' }} · {{ ind.inProduction.pages }} págs</div>
        <div class="l" [class.is-late]="ind.inProduction.lateCount > 0">
          <ng-container *ngIf="ind.inProduction.lateCount > 0">{{ ind.inProduction.lateCount }} atrasado{{ ind.inProduction.lateCount === 1 ? '' : 's' }} (em produção há mais de 5 dias)</ng-container>
          <ng-container *ngIf="ind.inProduction.lateCount === 0 && ind.inProduction.orders > 0">mais antigo: {{ ind.inProduction.oldestDays }} d em produção</ng-container>
          <ng-container *ngIf="ind.inProduction.orders === 0">nenhum pedido em produção</ng-container>
        </div>
      </button>

      <div class="kpi" matTooltip="Média de (saída da gráfica − início da produção) dos pedidos enviados nos últimos 30 dias. Pedidos sem início registrado ficam de fora.">
        <span class="dot dot-chip-ok"></span>
        <div class="t">Tempo médio de produção · 30 dias</div>
        <div class="big">{{ avgProductionLabel() }}</div>
        <div class="side">{{ ind.sent30.orders }} enviado{{ ind.sent30.orders === 1 ? '' : 's' }} · {{ ind.sent30.books }} livro{{ ind.sent30.books === 1 ? '' : 's' }}</div>
        <div class="l">
          <ng-container *ngIf="ind.measuredOrders30d > 0">base: {{ ind.measuredOrders30d }} de {{ ind.sent30.orders }} pedido{{ ind.sent30.orders === 1 ? '' : 's' }} com início registrado</ng-container>
          <ng-container *ngIf="ind.measuredOrders30d === 0">sem pedidos com início de produção registrado no período</ng-container>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <form class="filters" [formGroup]="form" (ngSubmit)="applyFilters()">
      <mat-form-field appearance="outline" class="field search">
        <mat-label>Buscar</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput formControlName="search" placeholder="Nº do pedido, cliente ou título">
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field wide">
        <mat-label>Impressão (tamanho/papel)</mat-label>
        <mat-select formControlName="listIdBookPrint" multiple>
          <mat-option *ngIf="!listBookPrint?.length" disabled>Nenhuma opção carregada</mat-option>
          <mat-option *ngFor="let bp of listBookPrint" [value]="bp.idBookPrint">{{ bp.bookPrintSize }} | {{ bp.bookPrintDescription }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field">
        <mat-label>Período por</mat-label>
        <mat-select formControlName="dateField">
          <mat-option *ngFor="let d of dateFieldOptions" [value]="d.value">{{ d.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field date">
        <mat-label>De</mat-label>
        <input matInput [matDatepicker]="dp1" formControlName="dateStart">
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field date">
        <mat-label>Até</mat-label>
        <input matInput [matDatepicker]="dp2" formControlName="dateEnd">
        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>

      <mat-slide-toggle formControlName="onlyLate" class="toggle" matTooltip="Só pedidos atrasados na etapa atual">Só atrasados</mat-slide-toggle>

      <div class="filters-actions">
        <button mat-stroked-button type="button" (click)="resetFilters()"><mat-icon>filter_alt_off</mat-icon> Limpar</button>
        <button mat-raised-button class="btn-primary" type="submit"><mat-icon>filter_alt</mat-icon> Aplicar</button>
      </div>
    </form>

    <!-- Lista -->
    <div class="tbl-wrap">
      <div class="tbl-top">
        <span><b>{{ total }}</b> pedido{{ total === 1 ? '' : 's' }} encontrado{{ total === 1 ? '' : 's' }}</span>
        <span class="mut">Ordenado por <b>aguardando produção</b> (mais antigos primeiro), depois em produção, depois histórico</span>
      </div>

      <div class="spinner" *ngIf="isLoading"><mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner></div>

      <div class="scroll" *ngIf="!isLoading">
        <table class="tbl">
          <thead>
            <tr>
              <th>Pedido</th><th>Cliente</th><th>Livros</th><th class="num">Páginas</th><th>Etapas</th><th>Status</th><th class="acts-col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr class="prod-row" *ngFor="let s of list; trackBy: trackBySale" [class.late]="s.isLate && (isWaiting(s) || isInProduction(s))">
              <td>
                <div class="main mono">#{{ s.saleNumber }}</div>
                <div class="mut">{{ s.saleDateTime | utcDate }}</div>
                <div class="tiny" *ngIf="s.nfeNumber">NF-e {{ s.nfeNumber }}</div>
              </td>
              <td>
                <div class="main">{{ s.clientName || '—' }}</div>
                <div class="mut" *ngIf="s.city">{{ s.city }}/{{ s.state }}</div>
                <div class="tiny mono" *ngIf="s.coreiosTrackingCode">{{ s.coreiosTrackingCode }}<span *ngIf="s.isManualLabel"> · etiqueta manual</span></div>
              </td>
              <td>
                <div class="main">{{ s.booksCount }} livro{{ s.booksCount === 1 ? '' : 's' }}</div>
                <div class="mut items"><div *ngFor="let i of s.listPrintCompanyKitItemStruct">{{ i.bookTitle }} <span class="x">×{{ i.quantity }}</span></div></div>
                <div class="tags"><span class="tag" *ngFor="let t of formatsOf(s)">{{ t }}</span></div>
              </td>
              <td class="num">
                <div class="main">{{ s.pagesCount }}</div>
                <div class="mut">págs</div>
              </td>
              <td>
                <div class="steps">
                  <ng-container *ngFor="let st of steps(s); let i = index">
                    <span class="bar" *ngIf="i > 0" [class.done]="!!st.date"></span>
                    <span class="step" [class.done]="!!st.date" [class.now]="isCurrentStep(s, i)"
                          [title]="st.label + (st.date ? ': ' + (st.date | utcDate) : ': pendente')">
                      <mat-icon *ngIf="st.date">check</mat-icon>
                      <mat-icon *ngIf="isCurrentStep(s, i)">more_horiz</mat-icon>
                    </span>
                  </ng-container>
                </div>
                <div class="steps-l">
                  <span *ngIf="s.datetimeProductionStarted">Início {{ s.datetimeProductionStarted | utcDate }}</span>
                  <span *ngIf="!s.datetimeProductionStarted && s.datetimeLabelGenerated">Etiqueta {{ s.datetimeLabelGenerated | utcDate }}</span>
                  <span *ngIf="s.sendDateTime"> · Saída {{ s.sendDateTime | utcDate }}</span>
                </div>
              </td>
              <td>
                <span [class]="statusClass(s.statusComputed)">{{ s.statusComputed }}</span>
                <span class="chip chip-crit late-chip" *ngIf="s.isLate && (isWaiting(s) || isInProduction(s))" matTooltip="Atrasado nesta etapa">atrasado</span>
                <div class="tiny" *ngIf="stageTime(s) as t">{{ t }}</div>
              </td>
              <td class="acts-col">
                <div class="acts">
                  <button mat-flat-button class="btn-primary act-main" *ngIf="isWaiting(s)" [disabled]="isActing" (click)="startProduction(s)" matTooltip="Registra agora o início da produção">
                    <mat-icon>play_arrow</mat-icon> Iniciar produção
                  </button>
                  <button mat-flat-button class="btn-primary act-main" *ngIf="isInProduction(s)" [disabled]="isActing" (click)="confirmSend(s)" matTooltip="Registra a saída da gráfica e avisa o cliente">
                    <mat-icon>done_all</mat-icon> Confirmar envio
                  </button>
                  <button mat-icon-button [disabled]="isActing" matTooltip="Baixar tudo (ZIP)" (click)="downloadAllFiles(s)"><mat-icon>archive</mat-icon></button>
                  <button mat-icon-button matTooltip="Ver livros e downloads" (click)="openItemsModal(s)"><mat-icon>menu_book</mat-icon></button>
                  <button mat-icon-button [matMenuTriggerFor]="rowMenu" aria-label="Mais"><mat-icon>more_vert</mat-icon></button>
                  <mat-menu #rowMenu="matMenu">
                    <button mat-menu-item (click)="openUrl(s.linkCorreiosCartaRemessa)" *ngIf="s.linkCorreiosCartaRemessa"><mat-icon>label</mat-icon> Baixar etiqueta dos Correios</button>
                    <button mat-menu-item (click)="openUrl(s.linkDanfe)" *ngIf="s.linkDanfe"><mat-icon>picture_as_pdf</mat-icon> Baixar DANFE</button>
                    <button mat-menu-item (click)="openUrl(s.linkXml)" *ngIf="s.linkXml"><mat-icon>code</mat-icon> Baixar XML</button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!list.length" class="empty">Nenhum pedido encontrado com os filtros atuais.</div>
      </div>

      <div class="legend">
        <span><span class="step done lg"><mat-icon>check</mat-icon></span> concluída</span>
        <span><span class="step now lg"><mat-icon>more_horiz</mat-icon></span> etapa atual</span>
        <span>Marcos: Etiqueta emitida · Início da produção · Saída da gráfica (entregue aos Correios) · Entregue</span>
        <span class="crit">Linha vermelha: aguardando há mais de 2 dias ou em produção há mais de 5 dias</span>
      </div>

      <mat-paginator [length]="total" [pageIndex]="page - 1" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                     [showFirstLastButtons]="true" (page)="onPage($event)"></mat-paginator>
    </div>
  </div>
</div>

<app-footer></app-footer>
